import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { freeSet } from '@coreui/icons';
import { ToastService } from 'angular-toastify';
import { isNil } from 'lodash-es';
import { Editor } from 'ngx-editor';
import { ApiService } from '../../api/api.service';
import { CoreService } from '../../services/core-service/core-service.service';
import { StorageService } from '../../services/storage.service';
import { Result, parseError } from '../../shared/interfaces';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
    selector: 'categorias-info',
    templateUrl: './categoria.component.html',
    styleUrl: './categoria.component.scss'
})
export class CategoriaComponent implements OnInit, OnDestroy {


    icons = freeSet;
    editor: Editor | any;
    html = '';
    public _image: string | any = '';

    formContent = this.fb.group({
        contenido: this.fb.control('', Validators.required)
    })
    private contenidoId = 4;
    private _imagenContenidoId = 5;
    private _imagenContenido: SafeResourceUrl | any;
    private _modoEdicion: boolean = false;


    constructor(
        private ntf: ToastService,
        private api: ApiService,
        private core: CoreService,
        private fb: FormBuilder,
        private storage: StorageService,
        private sanitizer: DomSanitizer
    ) {
        this._modoEdicion = this.storage?.token?.logueado || false;
    }

    ngOnInit(): void {
        this.obtenerContenido();
        this.obtenerImagen();
        this.editor = new Editor();
    }

    async obtenerContenido() {
        try {
            const path = `contenido/${this.contenidoId}`
            const result = (await this.api.consulta(path, false, [], {}, 'GET')).data as Result
            this.formContent.patchValue({ contenido: result.data.contenido })
            this.html = result.data.contenido
        } catch (e) {

        }
    }

    async obtenerImagen() {
        try {
            const path = `contenido/${this._imagenContenidoId}`
            const result = (await this.api.consulta(path, false, [], {}, 'GET')).data as Result
            const url = result.data.contenido;

                if (url && typeof url === 'string' && url.startsWith('https://')) {
                this._imagenContenido = this.sanitizer.bypassSecurityTrustResourceUrl(url);

                } else {
                this._imagenContenido = null;
                this.ntf.error('URL de contenido no válida o potencialmente insegura');
                }
                
        } catch (e) {

        }
    }

    async actualizarImagen(urlImage: string) {
        try {
            const path = `contenido/actualizar/${this._imagenContenidoId}`
            await this.api.consulta(path, true, [], { contenido: urlImage }, 'PUT')
            this.obtenerImagen();
            this.ntf.success(`Se actualizo la imagen.`)
        } catch (e) {
            this.ntf.error(`Error: ${parseError(e)}`);
        }
    }

    async actualizarContenido() {
        try {
            if (isNil(this.html) || this.html == '') {
                this.ntf.warn(`Ingrese el contenido antes de guardar los cambios.`);
                return;
            }
            const path = `contenido/actualizar/${this.contenidoId}`
            await this.api.consulta(path, true, [], this.formContent.getRawValue(), 'PUT')
            this.obtenerContenido();
            this.ntf.success(`Se actualizo el contenido.`)
        } catch (e) {
            this.ntf.error(`Error: ${parseError(e)}`);
        }
    }

    // make sure to destory the editor
    ngOnDestroy(): void {
        this.editor.destroy();
    }

    get modoEdicion(): boolean {
        return this._modoEdicion;
    }

    get imagenContenido(): string {
        return this._imagenContenido;
    }

}